
export enum Type{
    string=0,number=2,Date=3
}

export enum Operator{
    Equal=0,NotEqual=1,GreaterThan=2,GreaterThanEqual=3,LessThan=4,LessThanEqual=5,DataTypeCheck=6
}